<template>
  <div class="message-thread">
    <div class="dashboard-card light message" v-for="(message, index) in messages">
      <div class="upper">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="left d-inline-block">
              <div
                v-if="message.avatarFileUrl"
                class="user-avatar"
                :style="{ backgroundImage: `url(${message.avatarFileUrl})` }"
              />
              <div
                v-else
                class="user-avatar"
              />
            </div>
            <div class="right d-inline-block">
              <span class="name">
                {{message.senderDisplay}}
              </span>
              <span class="date d-lg-none">
                <b>{{ message.timestamp | date }}</b> <span class="d-none d-lg-inline">({{getTimeAgo(message.timestamp)}})</span>
              </span>
            </div>
          </div>
          <div class="d-none d-lg-block col-lg-6 text-right">
            <span class="date">
              <b>{{ message.timestamp | date }}</b> <span class="d-none d-lg-inline">&nbsp;({{getTimeAgo(message.timestamp)}})</span>
            </span>
          </div>
        </div>
      </div>
      <div class="message-content">
        <h2 v-if="message.heading">{{message.heading}}</h2>
        <p v-if="message.message">
          {{message.message}}
        </p>

        <router-link
          v-if="message.notification_type === 'group_session_payment_due'"
          to="/payments"
          class="btn btn-primary mt-4"
        >
          Payment Due
        </router-link>
        <router-link
          v-if="message.notification_type === 'appointment_payment_due'"
          to="/payments"
          class="btn btn-primary mt-4"
        >
          Payment Due
        </router-link>
        <router-link
          v-if="message.notification_type === 'appointment_request_declined'"
          to="/dashboard/user"
          class="btn btn-primary mt-4"
        >
          View Sessions
        </router-link>
        <router-link
          v-if="message.notification_type === 'appointment_request_confirmed'"
          to="/dashboard/user"
          class="btn btn-primary mt-4"
        >
          View Sessions
        </router-link>
        <router-link
          v-if="message.notification_type === 'new_appointment_request_received'"
          to="/dashboard/counselor?show_pending=true"
          class="btn btn-primary mt-4"
        >
          View Session
        </router-link>
        <router-link
          v-if="message.notification_type === 'new_appointment_request_created'"
          :to="{ name: $store.getters.currentUser.homeRouteName }"
          class="btn btn-primary mt-4"
        >
          View Sessions
        </router-link>
      </div>
      <div class="lower">
        <button
          v-if="index === 0 && message.canReply"
          type="button"
          @click="reply(message)"
          class="btn back-btn first"
        >
          <font-awesome-icon
            :icon="['fas', 'reply']"
            class="icon alt"
          />
        </button>
        <button
          v-if="index === 0 && message.counselor_user_id"
          type="button"
          @click="reply(null, message.counselor_user_id)"
          class="btn back-btn first"
        >
          <font-awesome-icon
            :icon="['fas', 'reply']"
            class="icon alt"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MessageThread',
  components: {

  },
  props: {
    messages: {
      type: Array,
    },
    reply: {
      type: Function,
    },
  },

  methods: {
    getTimeAgo(dt) {
      return moment(dt).fromNow();
    },
  },
};
</script>

<style lang="scss" scoped>
.message-thread {
  .message {
    .upper {
      border-bottom: solid 1px rgba(white, 0.2);
      padding-bottom: 30px;

      .left,
      .right {
        vertical-align: top;
      }

      .user-avatar {
        @include background-cover;
        @include border-radius(100px);

        background-image: url('~@/assets/img/default-user.jpg');
        height: 40px;
        width: 40px;
        margin-right: 15px;

        @media (max-width: $md-max) {
          margin-top: 3px;
        }
      }

      .name {
        display: block;
        font-weight: bold;

        @media (min-width: $lg-min) {
          line-height: 40px;
          font-size: 18px;
        }
      }

      .date {
        @media (max-width: $md-max) {
          opacity: 0.75;

          b {
            font-weight: normal;
          }
        }

        @media (min-width: $lg-min) {
          line-height: 40px;
        }
      }
    }

    .message-content {
      padding: 30px;

      h2 {
        margin-bottom: 30px;
      }

      @media (max-width: $md-max) {
        padding: 30px 0;
      }
    }

    .action-row {
      margin-top: 45px;

      .btn {
        margin-right: 10px;
      }

      @media (max-width: $sm-max) {
        .btn-primary,
        .btn-ghost {
          width: 100%;
          display: block;
          margin-right: 0;

          &.btn-primary {
            margin-bottom: 5px;
          }
        }
      }
    }

    .lower {
      text-align: right;

      .btn {
        font-size: 25px;

        &.first {
          margin-right: 15px;
        }
      }

      @media (max-width: $md-max) {
        text-align: left;
      }
    }
  }
}
</style>
